import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["query", "clearButton", "spinner", "searchButton"];
  connect() {
    console.log("Table Search Controller connected on", this.element);
    this.toggleClearButton();
  }

  onInput() {
    this.toggleClearButton();
  }

  toggleClearButton() {
    const value = this.queryTarget.value;
    if (value.trim() !== "") {
      this.clearButtonTarget.classList.remove("d-none");
    } else {
      this.clearButtonTarget.classList.add("d-none");
    }
  }

  // When a key is pressed in the query field…
  keyup(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.submit(event);
    }
  }

  clear(event) {
    event.preventDefault();
    this.queryTarget.value = "";
    this.toggleClearButton();
    this.submit(event);
  }

  // When the search button is clicked…
  searchClick(event) {
    event.preventDefault();
    this.submit(event);
  }

  // The main submission function using the Fetch API
  async submit(event) {
    // Prevent the default form submission
    event.preventDefault();

    // Show the spinner and hide the search icon
    this.spinnerTarget.classList.remove("d-none");
    this.searchButtonTarget.classList.add("d-none");

    const form = this.element; // the form element is the root element of this controller
    const url = form.action;
    const method = (form.method || "GET").toUpperCase();

    // Gather form data
    const formData = new FormData(form);
    let fetchUrl = url;
    let fetchOptions = {
      method: method,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/html"
      }
    };

    // For GET requests, append parameters to the URL
    if (method === "GET") {
      const params = new URLSearchParams(formData).toString();
      fetchUrl = url + "?" + params;
    } else {
      fetchOptions.body = formData;
    }

    try {
      const response = await fetch(fetchUrl, fetchOptions);
      if (response.ok) {
        const html = await response.text();

        // Get the target selector for updating the table from the form’s data attribute
        const updateSelector = form.dataset.tableSearchUpdateTarget;
        if (updateSelector) {
          const updateTarget = document.querySelector(updateSelector);
          if (updateTarget) {
            // Replace the table’s content with the returned HTML
            updateTarget.innerHTML = html;
          } else {
            console.warn(`No element found for selector ${updateSelector}`);
          }
        }
      } else {
        console.error("Search request failed with status", response.status);
      }
    } catch (error) {
      console.error("Error during search request:", error);
    } finally {
      // Hide the spinner and show the search icon
      this.spinnerTarget.classList.add("d-none");
      this.searchButtonTarget.classList.remove("d-none");
    }
  }
}
